import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import VirtueLogo from "../../assets/Virtue Logo Concept 1 White 1.png";
import { FaInstagram, FaLinkedin } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  const { lang } = useParams();
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const { t } = useTranslation("global");

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-container">
          <section className="footer-left">
            <img src={VirtueLogo} alt="Virtue Logo" className="footer-logo" />
            <p className="text">{t("footer.tagline")}</p>
          </section>
          <nav className="footer-right">
            <section className="category-container">
              <h3 className="footer-category-title">
                <Link to={`/${lang}/SoftwareSolutions`} onClick={scrollToTop}>
                  {t("footer.softwareSolutions")}
                </Link>
              </h3>
              <ul className="footer-options">
                <li>
                  <Link to={`/${lang}/SoftwareSolutions`} onClick={scrollToTop}>
                    {t("footer.webAppDevelopment")}
                  </Link>
                </li>
                <li>
                  <Link to={`/${lang}/SoftwareSolutions`} onClick={scrollToTop}>
                    {t("footer.erpCrmSolutions")}
                  </Link>
                </li>
                <li>
                  <Link to={`/${lang}/SoftwareSolutions`} onClick={scrollToTop}>
                    {t("footer.lowCodeNoCodeSolutions")}
                  </Link>
                </li>
              </ul>
            </section>
            <section className="category-container">
              <h3 className="footer-category-title">
                <Link to={`/${lang}/CreativeDesign`} onClick={scrollToTop}>
                  {t("footer.creativeDesign")}
                </Link>
              </h3>
              <ul className="footer-options">
                <li>
                  <Link to={`/${lang}/CreativeDesign`} onClick={scrollToTop}>
                    {t("footer.uiUxDesign")}
                  </Link>
                </li>
                <li>
                  <Link to={`/${lang}/CreativeDesign`} onClick={scrollToTop}>
                    {t("footer.brandIdentityVisuals")}
                  </Link>
                </li>
                <li>
                  <Link to={`/${lang}/CreativeDesign`} onClick={scrollToTop}>
                    {t("footer.graphicMotionDesign")}
                  </Link>
                </li>
              </ul>
            </section>
            <section className="category-container">
              <h3 className="footer-category-title">
                <Link to={`/${lang}/AdvertisingAndMedia`} onClick={scrollToTop}>
                  {t("footer.advertisingMedia")}
                </Link>
              </h3>
              <ul className="footer-options">
                <li>
                  <Link
                    to={`/${lang}/AdvertisingAndMedia`}
                    onClick={scrollToTop}
                  >
                    {t("footer.marketingStrategy")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/${lang}/AdvertisingAndMedia`}
                    onClick={scrollToTop}
                  >
                    {t("footer.socialMediaCampaign")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/${lang}/AdvertisingAndMedia`}
                    onClick={scrollToTop}
                  >
                    {t("footer.videoProductionEditing")}
                  </Link>
                </li>
              </ul>
            </section>
            <section className="category-container" id="last-container">
              <h3 className="footer-category-title">
                <Link to={`/${lang}/TermsOfUse`} onClick={scrollToTop}>
                  {t("footer.legal")}
                </Link>
              </h3>
              <ul className="footer-options">
                <li>
                  <Link to={`/${lang}/TermsOfUse`} onClick={scrollToTop}>
                    {t("footer.termsOfUse")}
                  </Link>
                </li>
                <li>
                  <Link to={`/${lang}/PrivacyPolicy`} onClick={scrollToTop}>
                    {t("footer.privacyPolicy")}
                  </Link>
                </li>
                <li>
                  <Link to={`/${lang}/ContactUs`} onClick={scrollToTop}>
                    {t("footer.contactUs")}
                  </Link>
                </li>
              </ul>
            </section>
          </nav>
        </div>
        <section className="footer-bottom">
          <div className="bottom">
            <div className="bottom-left">
              <p>{t("footer.poweredBy")}</p>
              <p className="footer-address">
                Şht. Ecvet Yusuf Cad. Öztek Apt. No.19/2, Yenişehir, Lefkoşa
              </p>
            </div>

            <div className="footer-follow-us">
              <div className="footer-icons">
                <a
                  href="https://www.instagram.com/virtueltd/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Instagram"
                >
                  <FaInstagram />
                </a>

                <a
                  href="https://www.linkedin.com/company/the-virtue-co/posts/?feedView=all"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Connect with us on LinkedIn"
                >
                  <FaLinkedin />
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </footer>
  );
};

export default Footer;
